(function () {
  'use strict';

  function reducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function speed(root) {
    var v = parseFloat(getComputedStyle(root).getPropertyValue('--bex-speed'));
    return isNaN(v) ? 450 : v;
  }

  function init(root) {
    if (!root || root.dataset.bexReady === 'true') return;
    root.dataset.bexReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bex-tab]'));
    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-bex-media]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-bex-group]'));
    var hoverSelect = root.getAttribute('data-hover') === 'true';

    /* ---- audience (Him / Her / Home / Pets) ---- */

    function setAudience(key) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-bex-tab') === key;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });

      medias.forEach(function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-bex-media') === key);
      });

      groups.forEach(function (g) {
        var on = g.getAttribute('data-bex-group') === key;
        g.classList.toggle('is-active', on);
        if (on) g.removeAttribute('aria-hidden');
        else g.setAttribute('aria-hidden', 'true');
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setAudience(tab.getAttribute('data-bex-tab'));
      });

      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        next.focus();
        setAudience(next.getAttribute('data-bex-tab'));
      });
    });

    /* ---- health categories inside each audience ---- */

    groups.forEach(function (group) {
      var cats = Array.prototype.slice.call(group.querySelectorAll('[data-bex-cat]'));
      var dots = Array.prototype.slice.call(group.querySelectorAll('[data-bex-dot]'));
      var lists = Array.prototype.slice.call(group.querySelectorAll('[data-bex-list]'));
      var box = group.querySelector('[data-bex-box]');
      var token = 0;

      function currentId() {
        var c = group.querySelector('[data-bex-cat].is-active');
        return c ? c.getAttribute('data-bex-cat') : null;
      }

      function markButtons(id) {
        cats.forEach(function (c) {
          var on = c.getAttribute('data-bex-cat') === id;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        dots.forEach(function (d) {
          var on = d.getAttribute('data-bex-dot') === id;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      function findList(id) {
        for (var i = 0; i < lists.length; i++) {
          if (lists[i].getAttribute('data-bex-list') === id) return lists[i];
        }
        return null;
      }

      function setCategory(id) {
        if (!id || id === currentId()) return;

        var prev = group.querySelector('[data-bex-list].is-active');
        var next = findList(id);

        markButtons(id);
        if (!next || next === prev) return;

        var my = ++token;

        if (reducedMotion() || !box || !prev) {
          lists.forEach(function (l) { l.classList.remove('is-active', 'is-leaving', 'is-entering'); });
          next.classList.add('is-active');
          next.scrollTop = 0;
          return;
        }

        var wait = Math.round(speed(root) * 0.45);
        var startH = box.offsetHeight;

        box.style.height = startH + 'px';
        prev.classList.add('is-leaving');

        window.setTimeout(function () {
          if (my !== token) return;

          lists.forEach(function (l) { l.classList.remove('is-active', 'is-leaving', 'is-entering'); });
          next.classList.add('is-active', 'is-entering');
          next.scrollTop = 0;

          /* measure the new natural height, then animate to it */
          box.style.transition = 'none';
          box.style.height = 'auto';
          var endH = box.offsetHeight;
          box.style.height = startH + 'px';
          void box.offsetHeight;
          box.style.transition = '';
          box.style.height = endH + 'px';

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              if (my === token) next.classList.remove('is-entering');
            });
          });

          window.setTimeout(function () {
            if (my === token) box.style.height = '';
          }, speed(root) + 60);
        }, wait);
      }

      cats.forEach(function (c) {
        c.addEventListener('click', function () {
          setCategory(c.getAttribute('data-bex-cat'));
        });
      });

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          setCategory(d.getAttribute('data-bex-dot'));
        });
        if (hoverSelect) {
          d.addEventListener('mouseenter', function () {
            setCategory(d.getAttribute('data-bex-dot'));
          });
        }
      });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bex]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
